import { PositionProps } from '@chakra-ui/react'
import { HTMLAttributes } from 'react'
import { DisplayProps, MarginProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSAssetTag from '../PDSAssetTag/PDSAssetTag'
import PDSBox from '../PDSBox/PDSBox'
import PDSFlexBox from '../PDSFlexBox/PDSFlexBox'
import PDSText from '../PDSText/PDSText'

type BaseProps = HTMLAttributes<HTMLSpanElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  assets: AssetListItem[]
  title: string
  titleColor?: string
} & BaseProps

type AssetListItem = {
  name?: string
  symbol: string
  value: number | string
}
export default function PDSAssetList({
  assets,
  titleColor,
  testId,
  title,
}: Props) {
  return (
    <PDSBox width="100%" testId={testId}>
      <PDSBox>
        <PDSText color={titleColor} weight="semibold">
          {title}
        </PDSText>
      </PDSBox>
      <PDSBox marginLeft={SIZE.s8}>
        {assets.map((asset, i) => {
          const backgroundColor = i % 2 === 0 ? COLOR.grey100 : COLOR.grey200

          return (
            <PDSBox
              key={`${asset.name}-${i}`}
              backgroundColor={backgroundColor}
            >
              <PDSFlexBox
                alignItems="center"
                gap={SIZE.s16}
                justifyContent="space-between"
                paddingY={SIZE.s12}
                paddingX={SIZE.s8}
              >
                <PDSBox>
                  <PDSAssetTag symbol={asset.symbol} />
                </PDSBox>

                {asset.name ? (
                  <PDSBox
                    flex={1}
                    style={{
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                    overflow="hidden"
                  >
                    <PDSText size="md" weight="medium">
                      {asset.name}
                    </PDSText>
                  </PDSBox>
                ) : null}
                <PDSText size="md" weight="medium">
                  {asset.value}
                </PDSText>
              </PDSFlexBox>
            </PDSBox>
          )
        })}
      </PDSBox>
    </PDSBox>
  )
}
